/**
 * @docs https://docs.google.com/spreadsheets/d/16G5TlV9RrO7OhNT8iBSHx_kMSpOGuZ2nofEAQCdUfjM/edit#gid=1536912187
 *
 * Usage:
 * 1. WORKFLOW_STATE_TO_STATUS_MAP[workflowState][workflowSubState] => state key
 * 2. POST_SUBMIT_STATUS_MAP[state key] => state map
 * 3. "state map" contains information needed to by list view and detail view
 */

export enum REGISTERED_WORKFLOW_STATES {
  WORKFLOW_SETUP = 'Submission Setup',
  EDIT_ANNUITY = 'Edit Annuity',
  CUSTOMER_CONFIRMATION = 'Customer Confirm Application',
  SUITABILITY = 'Suitability',
  ID_CHECK = 'ID Check',
  OFFER_ACCEPTANCE = 'Application',
  ISSUE = 'Issuance',
  CANCEL = 'Canceled',
  SUITABILITY_APPROVED = 'Approved',
  SUITABILITY_REJECTED = 'Rejected',
  IN_FORCE = 'In Force',
  OPERATIONS_REVIEW = 'Operations Review',
  ADDITIONAL_SIGNATURES = 'Additional Signatures',
}

export enum REGISTERED_WORKFLOW_SUB_STATES {
  INITIALIZATION = 'Initializing',
  ROUTING = 'Routing',
  EDITING = 'Editing',
  WAITING_CUSTOMER_SIGNATURE = 'Waiting for customer signature',
  REVIEWING = 'Reviewing',
  VERIFYING = 'Verifying',
  WAITING_ANNUITY_ACCEPTANCE = 'Waiting for Annuity Acceptance',
  PROCESSING = 'Processing',
  CANCEL = 'Canceled',
  OFFER_READY_TO_SEND = 'Offer ready to send',
  SUITABILITY_REJECTED = 'Suitability Rejected',
  ISSUED = 'Issued',
  OPERATIONS_REVIEW = 'Operations Review',
  TIMEOUT = 'Timeout',
  ADDITIONAL_SIGNATURES = 'Waiting for additional signatures',
}

export enum PRE_SUBMIT_STATUS_MAP_KEYS {
  APPLICATION_STARTED = 'applicationStarted',
  SUITABILITY_STARTED = 'suitabilityStarted',
  FR3013_STARTED = 'fr3013Started',
  REPLACEMENT_STARTED = 'replacementStarted',
  CERTIFICATE_OF_TRUST_STARTED = 'certificateOfTrustStarted',
}

export enum POST_SUBMIT_STATUS_MAP_KEYS {
  APPLICATION_SENT = 'applicationSent',
  APPLICATION_EDIT = 'applicationEdit',
  SUBMITTED = 'submitted',
  SUITABILITY_REVIEW = 'review',
  REJECTED = 'rejected',
  APPROVED = 'approved',
  OFFER_ACCEPTED = 'offerAccepted',
  CANCELLED = 'Cancelled',
  SUITABILITY_REJECTED = 'Suitability Rejected',
  SUITABILITY_APPROVED = 'Suitability Approved',
  OPERATIONS_REVIEW = 'operationsReview',
  TIMEOUT = ' timeout',
  ADDITIONAL_SIGNATURES = 'Additional Signatures',
}

export enum POST_ISSUE_STATUS_MAP_KEYS {
  IN_FORCE = 'inForce',
}

export const STATUSES = {
  [PRE_SUBMIT_STATUS_MAP_KEYS.APPLICATION_STARTED]: 'Application Started',
  [PRE_SUBMIT_STATUS_MAP_KEYS.SUITABILITY_STARTED]: 'Suitability Form Started',
  [PRE_SUBMIT_STATUS_MAP_KEYS.FR3013_STARTED]: 'FR3013 Form Started',
  [PRE_SUBMIT_STATUS_MAP_KEYS.REPLACEMENT_STARTED]: 'Replacement Form Started',
  [PRE_SUBMIT_STATUS_MAP_KEYS.CERTIFICATE_OF_TRUST_STARTED]: 'Certificate of Trust Form Started',
  [POST_SUBMIT_STATUS_MAP_KEYS.APPLICATION_SENT]: 'Application sent to client',
  [POST_SUBMIT_STATUS_MAP_KEYS.APPLICATION_EDIT]: 'Application in edit mode',
  [POST_SUBMIT_STATUS_MAP_KEYS.SUBMITTED]: 'Application Submitted',
  [POST_SUBMIT_STATUS_MAP_KEYS.SUITABILITY_REVIEW]: 'Suitability Review',
  [POST_SUBMIT_STATUS_MAP_KEYS.SUITABILITY_REJECTED]: 'Suitability Rejected',
  [POST_SUBMIT_STATUS_MAP_KEYS.SUITABILITY_APPROVED]: 'Application Approved',
  [POST_SUBMIT_STATUS_MAP_KEYS.REJECTED]: 'Application Rejected',
  [POST_SUBMIT_STATUS_MAP_KEYS.APPROVED]: 'Application Approved',
  [POST_SUBMIT_STATUS_MAP_KEYS.OFFER_ACCEPTED]: 'Offer accepted by client',
  [POST_SUBMIT_STATUS_MAP_KEYS.CANCELLED]: 'Cancelled',
  [POST_SUBMIT_STATUS_MAP_KEYS.OPERATIONS_REVIEW]: 'Preparing Documents for Signature',
  [POST_SUBMIT_STATUS_MAP_KEYS.ADDITIONAL_SIGNATURES]: 'Collecting signatures and documents from cosigners',
  [POST_ISSUE_STATUS_MAP_KEYS.IN_FORCE]: 'In Force',
};

export const SUB_STATUS = {
  offerNotSent: 'Offer not yet sent to client',
  offerSent: 'Offer sent to client',
  offerReadyToSend: 'Offer ready to send to client',
};

export enum ApplicationStages {
  PRE_SUBMIT = 'PRE_SUBMIT',
  POST_SUBMIT = 'POST_SUBMIT',
  POST_ISSUE = 'POST_ISSUE',
}

export type AnnuitySummaryInfo = {
  applicationFormQsID: string;
  suitabilityFormQsID: string;
  replacementFormQsID: string;
  cotFormQsID: string;
  fR3013FormQsID: string;
  workflowState: string;
  workflowSubState: string;
  policyNumber: string;
};
